
    import { Vue, Component, Prop } from "vue-property-decorator";
    import { BaseVue } from "@newview/base-web";
    import {AutoCompleteItemApi, AutoItemDataApi} from "@newview/smartsite-api";
    import {QueryWrapper} from "@newview/infrastructure";
    @Component({
        name: "AutocompleteInput"
    })
    export default class AutocompleteInput extends BaseVue {
        autoCompleteItemApi: AutoCompleteItemApi = new AutoCompleteItemApi();
        autoItemDataApi: AutoItemDataApi = new AutoItemDataApi();

        @Prop({ default: "" }) value!: String;
        @Prop({ default: false }) disabled!: Boolean;
        @Prop({ default: "" }) placeholder!: String;
        @Prop({ default: "" }) dataKey!: String;

        data: any = [];

        mounted() {
            this.loadData();
        }

        async loadData(){
            debugger
            let res = await this.autoCompleteItemApi.getEntityByFilter(new QueryWrapper().eq("ItemKey", this.dataKey));
            if(res.code == 200){
                let res2 = await this.autoItemDataApi.getEntities(new QueryWrapper().eq("ItemId", res.data.Id))
                if(res2.code == 200 && res2.data.length>0){
                    this.data = res2.data.map(e => e.DataValue);
                }
            }
        }

        filterMethod(value, option) {
            return option.indexOf(value) !== -1;
        }
    }
